import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../base";
import { Job, Plan } from "../../domain/models/master-plan";
import { GetPlansByMasterPlanAndSegmentRequest } from "../../domain/requests";
import { PlanningPortalRepository } from "../../repositories";

@Injectable({providedIn: 'root'})
export class GetPlansByMasterPlanAndSegmentUsecase implements UseCase<GetPlansByMasterPlanAndSegmentRequest, Job[]> {

  constructor(private planningPortalRepository: PlanningPortalRepository) {
  }

  execute(params: GetPlansByMasterPlanAndSegmentRequest): Observable<Job[]> {
    return this.planningPortalRepository.GetPlansByMasterPlanAndSegment(params);
  }
}